import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { StoreState } from '~/reducer';
import { userSettingsStoreStateSelector } from '~/selectors';
import { AppDispatch } from '~/store';

import { getUserSettings } from '../../slice';

export const HandleUserSettingsRequire: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();

  const requiredUserSettings = useSelector((state: StoreState) => {
    return userSettingsStoreStateSelector(state).requiredUserSettings;
  });

  React.useEffect(() => {
    if (!requiredUserSettings || requiredUserSettings.length) {
      (async () => {
        try {
          await dispatch(getUserSettings(requiredUserSettings));
        } catch {}
      })();
    }
  }, [dispatch, requiredUserSettings]);

  return null;
};
